'use client'

import { type Media } from '@/payload-types'
import React from 'react'
import { CMSLink } from '@/components/Link'
import RichText from '@/components/RichText'
import { Subheading } from '@/components/ui/subheading'
import { cn } from '@/utilities/ui'
import { RichTextType } from '@/utilities/types'
import { Media as MediaComponent } from './Media'

export const IdeaCard: React.FC<{
  title: string
  icon: number | Media
  description: RichTextType
  variant?: 'light' | 'dark'
}> = ({ title, icon, description, variant = 'dark' }) => {
  return (
    <div className="group flex flex-col items-start gap-[20px]">
      {typeof icon === 'object' && (
        <div>
          <MediaComponent
            resource={{
              ...icon,
              width: 24,
              height: 24,
            }}
            placeholder="empty"
          />
        </div>
      )}
      <Subheading size="md" className={cn(variant === 'light' ? 'text-light' : 'text-dark')}>
        {title}
      </Subheading>
      <RichText
        className={cn(
          'prose-p:!text-body-sm max-w-[500px] text-balance',
          variant === 'light' ? 'prose-light' : 'prose-dark',
        )}
        data={description}
      />
      <CMSLink
        url={'https://forum.sia.tech/t/about-the-grants-category/228'}
        variant="link-highlighter"
        newTab
        size="clear"
        className="group-hover:underline"
      >
        Apply for a grant
      </CMSLink>
    </div>
  )
}
